export const getToken = () => {
  try {
    const token = localStorage.getItem('token');
    return token || null;
  } catch (error) {
    return null;
  }
};

export const getRequester = () => {
  try {
    const requester = localStorage.getItem('requester');
    return requester || null;
  } catch (error) {
    return null;
  }
};

export const getScholarId = () => {
  try {
    const scholar_id = localStorage.getItem('scholar_id');
    return scholar_id || null;
  } catch (error) {
    return null;
  }
};

export const setUserSession = (data) => {
  try {
    // Set ID based on user type and only if provided
    if (data.requester === 'admin') {
      // Only set admin_id if id is provided
      if (data.id) {
        localStorage.setItem('admin_id', data.id);
      }
    } else {
      // For scholars, still set the ID if provided
      if (data.id) {
        localStorage.setItem('scholar_id', data.id);
      }
    }
    
    // Store token expiry if provided
    if (data.token_expiry) {
      localStorage.setItem('token_expiry', data.token_expiry);
    }
    
    return true;
  } catch (error) {
    return false;
  }
};

export const clearUserSession = () => {
  try {
    // Clear all authentication-related items
    localStorage.removeItem('token');
    localStorage.removeItem('token_expiry');
    localStorage.removeItem('id');
    localStorage.removeItem('admin_id');
    localStorage.removeItem('scholar_id');
    localStorage.removeItem('requester');
    localStorage.removeItem('username');
    
    // Clear user profile data
    localStorage.removeItem('first_name');
    localStorage.removeItem('last_name');
    localStorage.removeItem('middle_name');
    localStorage.removeItem('suffix');
    localStorage.removeItem('email');
    localStorage.removeItem('gender');
    localStorage.removeItem('course');
    localStorage.removeItem('scholarType');
    
    // Clear OTP data
    localStorage.removeItem('otp');
    localStorage.removeItem('otp_expiry');
    
    // Clear metadata
    localStorage.removeItem('added_by');
    localStorage.removeItem('added_on');
    localStorage.removeItem('updated_by');
    localStorage.removeItem('updated_on');
    localStorage.removeItem('is_deleted');
    
    // Clear other application data
    localStorage.removeItem('loglevel');
    
    // Clear UI preferences
    localStorage.removeItem('sidebar_collapsed');
    localStorage.removeItem('admin_sidebar_collapsed');
    
    return true;
  } catch (error) {
    return false;
  }
};
